import React from 'react'
import { CheckmarkFilled, CheckboxEmpty } from '@/assets/icons'

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  id?: string
  size?: number
  className?: string
  disabled?: boolean
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  id,
  size = 24,
  className = '',
  disabled = false,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
      e.preventDefault()
      onChange(!checked)
    }
  }

  return (
    <div
      role="checkbox"
      tabIndex={disabled ? -1 : 0}
      aria-checked={checked}
      aria-disabled={disabled}
      id={id}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`inline-flex items-center justify-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-lg transition-all duration-200 ${
        disabled ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105'
      } ${className}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      {checked ? (
        <CheckmarkFilled size={size} />
      ) : (
        <CheckboxEmpty size={size} />
      )}
    </div>
  )
}
